"use client";

import React, { useMemo } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import "./FashionHeaderToggleButtons.scss";

const TOGGLE_BUTTONS = [
  {
    id: "alfamall",
    label: "ALFAMALL",
    href: "/",
  },
  {
    id: "alfafashion",
    label: "ALFA FASHION",
    href: "https://alfamall.com/fashion",
    // href: "/fashion?q=v1",

  },
];


const FashionHeaderToggleButtons = () => {
  const pathname = usePathname();
  
  const isButtonActive = (href) => {
    if (href === "/") {
      return !pathname.includes("/fashion");
    }
    return pathname.includes("/fashion");
  };

  const isFashionPage = useMemo(() => {
    return pathname.includes("/fashion");
  }, [pathname]);

  const isMobileViewport = () =>
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(max-width: 768px)").matches;

  /** Same-route tap on mobile: full navigation so the page actually reloads. */
  const handleToggleLinkClick = (e, href) => {
    debugger;
    debugger;
    if (typeof window === "undefined") return;
    if (!isMobileViewport()) return;
    if (window.location.pathname !== href) return;
    e.preventDefault();
    window.location.href = href;
  };

  return (
    <div className={`fashion-header-toggle-buttons ${isFashionPage ? "fashion-header-toggle-buttons--fashion" : "fashion-header-toggle-buttons--alfamall"}`}>
      <div className="fashion-header-toggle-buttons__container">
        {TOGGLE_BUTTONS.map((button) => (
          <Link
            key={button.id}
            href={button.href}
            // onClick={(e) => handleToggleLinkClick(e, button.href)}
            className={`fashion-header-toggle-buttons__tab ${isButtonActive(button.href)
                ? "fashion-header-toggle-buttons__tab--active"
                : ""
              }`}
          >
            <span className="fashion-header-toggle-buttons__label">
              {button.label}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FashionHeaderToggleButtons;
